<template>
    <div class="tw-px-2 lg:tw-px-6 tw-py-10 tw-space-y-2">
        <!-- Item -->
        <!-- Las primeras filas toman el color de su puesto del podio (antes,
             siempre 3 y con los hex incrustados); el resto, neutro. -->
        <div
            v-for="(user, index) in users"
            :key="user.email"
            class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-full"
            :class="index < podium ? 'tw-shadow' : 'tw-bg-[#FCFCFC] tw-text-black'"
            :style="index < podium ? { backgroundColor: colors[index], color: textColors[index] } : null"
        >
            <div>
                <v-avatar color="primary" size="30">
                    <img :src="user.profile_photo_url" alt="" />
                </v-avatar>
                <span class="tw-text-xs tw-font-bold tw-ml-2">{{ user.fullName }}</span>
            </div>
            <div>
                <span class="tw-text-xs tw-font-bold">{{ user.total }} pts.</span>

            </div>
        </div>
        <!-- End Item -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { placeColors, placeTextColors, podiumSize } from '@/utils/leaderboardPlaces'

export default {
    props: {
        users: {
            type: [Array, Object],
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters({
            config: 'event/eventRegistryConfig',
        }),
        podium() {
            return podiumSize(this.config)
        },
        colors() {
            return placeColors(this.config)
        },
        textColors() {
            return placeTextColors(this.config)
        },
    },
}
</script>